import React from "react";
import { useTranslation } from "react-i18next";

const getClassNameForAvailability = (availability) => {
  if (availability >= 98.0) {
    return "light-green accent-1";
  } else if (availability >= 90.0) {
    return "amber lighten-4";
  } else if (availability === 0.0) {
    return "grey lighten-2";
  }
  return "deep-orange lighten-4";
};

const getClassNameForQcIndex = (availability, qcIndex) => {
  if (availability <= 0) {
    return "grey lighten-2";
  }
  if (qcIndex >= 80) {
    return "light-green accent-1";
  } else if (qcIndex >= 50) {
    return "yellow lighten-3";
  } else if (qcIndex === 0) {
    return "grey lighten-2";
  }
  return "deep-orange lighten-4";
};

export const DataAvailabilityModal = ({ streamAvailabilities, onClose }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        position: "fixed",
        zIndex: 10681,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div id="modal3" className="modal">
        <div className="modal-content">
          <div className="modal-title">
            {t("page.continuous-data.availabilityAndQcIndex")}
          </div>
          <br />
          <span>
            {t("others.tableRowCounter", { rows: streamAvailabilities.length })}
          </span>
          <span style={{ float: "right" }}>
            ※ {t("color.green")}: &ge; 80, {t("color.yellow")}: &ge; 50,{" "}
            {t("color.red")}: &lt; 50, {t("color.gray")}: 0 (QC Index)
          </span>
          <div className="overflow-auto">
            <table className="table-bordered highlight datatable table-nowrap mt10 modal-scroll-min-size">
              {/* <colgroup>
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
              </colgroup> */}
              <tbody>
                <tr>
                  <th className="first">{t("w.stationCode")}</th>
                  <th className="first">{t("w.stationName")}</th>
                  {/* <th className="first">{t("w.locationCode")}</th> */}
                  <th className="first">{t("w.channelCode")}</th>
                  <th className="first">
                    <div data-tooltip-text="">QC Index</div>
                  </th>
                  <th className="first">{t("w.availability")}</th>
                  <th className="first">
                    <div data-tooltip-text="">Time Quality</div>
                  </th>
                  <th className="first">
                    <div data-tooltip-text="">Mass Position</div>
                  </th>
                </tr>
                {streamAvailabilities.map((stream) => (
                  <tr
                    key={stream.streamId}
                    className={getClassNameForQcIndex(
                      stream.availability,
                      stream.qcIndex
                    )}
                  >
                    <td className="center-align">{stream.station}</td>
                    <td className="center-align">{stream.stationName}</td>
                    {/* <td className="center-align">{stream.location}</td> */}
                    <td className="center-align">{stream.channel}</td>
                    <td className="center-align">
                      {stream.availability > 0 ? stream.qcIndex : 0}
                    </td>
                    <td className="center-align">
                      {stream.availability.toFixed(0)}%
                    </td>
                    <td className="center-align">
                      {stream.availability > 0
                        ? stream.timingQuality?.point ?? "-"
                        : "-"}
                    </td>
                    <td className="center-align">
                      {stream.availability > 0
                        ? stream.massPosition?.point ?? "-"
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <a
          className="modal-close waves-effect waves-green btn-flat"
          onClick={onClose}
        >
          <i className="ion ion-md-close"></i>
        </a>
      </div>
    </div>
  );
};
